<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>

					<b-form-group label="Are there any traffic signals infrastructure which need to be altered or disabled?">
					<p>This would include pedestrian corridors, disabling a left turn arrow or in the case of a closed sidewalk a walk/ don't walk signal.</p>
					</b-form-group>
					<div v-if="!$store.state.isMobile" :class="preset[0].expandTrafficSignalsAltered ? 'collapsible expanded collapsible__trafficSignalsAltered' : 'collapsible collapsible__trafficSignalsAltered collapsed'">
					<div class="collapsible-heading">
							<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpand">
								<b-img v-show="!preset[0].expandTrafficSignalsAltered" src="/img/100x100/dark/traffic-light.png"></b-img>
								<b-img v-show="preset[0].expandTrafficSignalsAltered"  src="/img/100x100/light/traffic-light.png"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">Altered Traffic Signals <small>{{getTitleText()}}</small></div>
						<div class="collapsible-heading__review-blocks" @click="onToggleExpand"><div class="flex-table"><div class="flex-table-cell">Review Blocks</div></div></div>
						<div class="collapsible-heading__toggle">
							<div class="flex-table">
							<b-button href="#" variant="collapsible"
							:class="preset[0].expandTrafficSignalsAltered ? ' flex-table-cell' : 'collapsed flex-table-cell'"
							:aria-expanded="preset[0].expandTrafficSignalsAltered ? 'true' : 'false'"
							:aria-controls="'collapseSignalListing'"
							@click="onToggleExpand"
							>
						<span class="when-opened">
						<font-awesome-icon icon="chevron-down" />
						</span>
						<span class="when-closed">
						<font-awesome-icon icon="chevron-right" />
						</span>
						</b-button>
					</div>
							</div>
							</div>
						</div>
					<b-collapse :id="'collapseSignalListing'" :visible="preset[0].expandTrafficSignalsAltered" class="collapsible-entries">
						<div class="collapsible-entries__wrapper">
							<div :class="classes(b2index)" v-for=" (b, b2index) in value" :key="'eblts2index'+b2index+'-'+renderCounter">
									<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__icon"><b-img src="/img/lcr/traffic-light.png"></b-img></div>
										<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
										<div class="collapsible-entry__switch">
										<div class="yes-no-lock-switch-field">
												<input :id="switchId('ebltrafficSignalsAltered',b2index)"  class="yes-no-lock-switch" :checked="isEntry(b2index)" type="checkbox" @change="toggleRemoveBlock(b2index)" >
												<label :for="switchId('ebltrafficSignalsAltered',b2index)"></label>
											</div>
										</div>
										<div class="collapsible-entry__title flex-grow-1"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
									</div>
								</div>
						</div>
					</b-collapse>
				</div>

				<div v-if="1 == 2 && $store.state.isMobile" :class="preset[0].expandTrafficSignalsAltered ? 'collapsible expanded collapsible__trafficSignalsAltered' : 'collapsible collapsible__trafficSignalsAltered collapsed'">
					<div class="collapsible-heading">
							<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpand">
								<b-img src="/img/100x100/dark/traffic-light.png"></b-img>
								<!-- <b-img v-show="preset[0].expandTrafficSignalsAltered"  src="/img/100x100/light/traffic-light.png"></b-img> -->
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">Altered Traffic Signals <small>{{getTitleText()}}</small></div>
						<div class="collapsible-heading__toggle">
							<div class="flex-table">
							<b-button href="#" variant="collapsible"
							:class="preset[0].expandTrafficSignalsAltered ? ' flex-table-cell' : 'collapsed flex-table-cell'"
							:aria-expanded="preset[0].expandTrafficSignalsAltered ? 'true' : 'false'"
							:aria-controls="'collapseSignalListing'"
							@click="onToggleExpand"
							>
						<span class="when-opened">
						<font-awesome-icon icon="chevron-down" />
						</span>
						<span class="when-closed">
						<font-awesome-icon icon="chevron-right" />
						</span>
						</b-button>
					</div>
							</div>
							</div>
						</div>
					<b-collapse :id="'collapseSignalListing'" :visible="preset[0].expandTrafficSignalsAltered" class="collapsible-entries">
						<div class="collapsible-entries__wrapper">
							<div :class="classes(b2index)" v-for=" (b, b2index) in value" :key="'eblts2index'+b2index+'-'+renderCounter">
									<div class="d-flex collapsible-entry">
										<div class="collapsible-entry__switch">
											<div class="yes-no-lock-switch-field">
												<input :id="switchId('ebltrafficSignalsAltered',b2index)"  class="yes-no-lock-switch" :checked="isEntry(b2index)" type="checkbox" @change="toggleRemoveBlock(b2index)" >
												<label :for="switchId('ebltrafficSignalsAltered',b2index)"></label>
											</div>
										</div>
										<div class="collapsible-entry__title flex-grow-1"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
										<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
									</div>
								</div>
						</div>
					</b-collapse>
				</div>



				<div v-if="$store.state.isMobile" :class="preset[0].expandTrafficSignalsAltered ? 'collapsible expanded collapsible__trafficSignalsAltered' : 'collapsible collapsible__trafficSignalsAltered collapsed'">
					<div class="collapsible-heading">
							<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpandSingle">
								<b-img src="/img/100x100/dark/traffic-light.png"></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpandSingle">Altered Traffic Signals
								<div class="collapsible-heading__subtitle" v-html="getTitleText()" ></div></div>
						<div class="collapsible-heading__toggle">
							<div class="flex-table">
							<b-button href="#" variant="collapsible"
							:class="preset[0].expandTrafficSignalsAltered ? ' flex-table-cell' : 'collapsed flex-table-cell'"
							:aria-expanded="preset[0].expandTrafficSignalsAltered ? 'true' : 'false'"
							:aria-controls="'collapseSignalListing'"
							@click="onToggleExpandSingle"
							>
						<span class="pr-3">
						<font-awesome-icon icon="chevron-right" />
						</span>
						</b-button>
					</div>
							</div>
							</div>
						</div>
				</div>

				<div v-if="$store.state.isMobile">
					<transition name="slide-fade" tag="div">
					<div class="d-block section-slide-panel" v-if="showPanel">
						<div class="top-controls">
							<button type="button" @click="onApplySingle">
								<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
							</button>
						</div>
							<div class="panels-body edit-lcr-panels-body panels-body-padded panels-no-menu">
								<div class="panels-nav-title" v-html="getNavTitle"></div>
								<div class="panels-body-title">
									<b-img src="/img/100x100/dark/traffic-light.png"></b-img>
									<div class="flex-grow-1 pt-3" @click="onToggleExpand(uindex)">Altered Traffic Signals</div>
								</div>
								<div class="panels-body-content"  v-keep-scroll-position>
									<div :class="classes(b2index)" v-for=" (b, b2index) in value" :key="'eblts2index'+b2index+'-'+renderCounter">
											<div class="d-flex collapsible-entry">
												<div class="collapsible-entry__switch">
													<div class="yes-no-lock-switch-field">
														<input :id="switchId('ebltrafficSignalsAltered',b2index)"  class="yes-no-lock-switch" :checked="isEntry(b2index)" type="checkbox" @change="toggleRemoveBlock(b2index)" >
														<label :for="switchId('ebltrafficSignalsAltered',b2index)"></label>
													</div>
												</div>
												<div class="collapsible-entry__title flex-grow-1"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <strong>{{b.fromStreet.value}}</strong> and <strong>{{b.toStreet.value}}</strong></a></div>
												<div class="collapsible-entry__map-button"><b-button class="pl-1 pr-1 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
											</div>
										</div>
								</div>
							</div>
							<div class="panels-apply panels-apply-only">
								<div class="d-flex">
										<div class="panels-apply__close"><b-button @click="setAllYes()" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />All</b-button></div>
										<div class="panels-apply__open"><b-button @click="setAllNo()" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />None</b-button></div>
										<div class="panels-apply__save"><b-button @click="onApplySingle()" variant="secondary" class="save-button" type="button"><img src="/img/assets/icon-checkmark-blue.svg"/><span class="btn__text">Apply</span></b-button></div>
									</div>
								</div>
						</div>
					</transition>
				</div>


			</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Vue from 'vue'

export default {
	name: 'LaneClosureRequestBlockSignalListing',
	props: ['value', 'preset', 'renderCounter'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			backup: {},
			showPanel:false,
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
	watch: {

	},
	computed: {
		getNavTitle() {
			return "Select Blocks to Alter";
		},
	},
	methods: {
		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__traffic";
				}
			}
			return "collapsible collapsible__traffic collapsed";
		},
		isExpanded(u) {
			return this.preset[0].expandTrafficSignalsAltered;
			// if (u) {
			// 	if (typeof u.expand != "undefined") {
			// 		this.preset[0].expandTrafficSignalsAltered
			// 	}
			// }
			// return false;
		},
		classes: function(index) {
			if (this.isEntry(index)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		getTitleText(uindex) {
			let title = "";
			let qty = 0;
			let found = false;
			if (this.value && this.preset) {
				for (var xx = 0; xx < this.value.length; xx++) {
					found = false;
					if (this.value[xx].trafficSignalsAltered.value == 1) {
						found = true;
					}
					if (found) {
						qty++;
					}
				}
			}
			var  blockText = "blocks";
			if (this.value.length == 1) {
				blockText = "block";
			}
			if (qty == 1) {
				title = qty + " of " + this.value.length + " " + blockText;
			} else {
				if (qty == 0) {
					title = "no blocks";
				} else {
					title = qty + " of " + this.value.length + " " + blockText;
				}
			}
			if (qty == this.value.length) {
				title = "all blocks";
			}
			if (this.$store.state.isMobile || qty == 0) {
				return title;
			} else {
				return " ("+title+")";
			}
		},

		isEntry: function(index) {
			if (this.value) {
				if (this.value[index]) {
					if (this.value[index].trafficSignalsAltered.value == 1) {
								return true;
					}
				}
			}
			return false;
		},
		canBeAdded: function(index) {
			if (this.value) {
				if (this.value[index]) {
					if (this.value[index].trafficSignalsAltered.value == 1) {
								return false;
					}
				}
			}
			return true;
		},
		switchId(prefix,block) {
			return prefix+"-"+block;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		showOnMap: function(id) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "trafficSignal", laneId: 1});
		},
		showMap: function() {
			Vue.prototype.$bus.$emit("map:toggle", null);
		},

		toggleRemoveBlock: function(index,uindex) {
			if (this.isEntry(index)) {
				Vue.prototype.$bus.$emit("block:list-remove-trafficSignalsAltered",{trafficSignalsAltered:0, blockId:this.value[index].blockId});
			} else {
				Vue.prototype.$bus.$emit("block:list-add-trafficSignalsAltered",{trafficSignalsAltered:1, blockId:this.value[index].blockId});
			}
		},


		setAllYes: function() {
			for (var index = 0; index < this.value.length; index++) {
				if (!this.isEntry(index)) {
					Vue.prototype.$bus.$emit("block:list-add-trafficSignalsAltered",{trafficSignalsAltered:1, blockId:this.value[index].blockId});
				}
			}
		},
		setAllNo: function() {
			for (var index = 0; index < this.value.length; index++) {
				if (this.isEntry(index)) {
					Vue.prototype.$bus.$emit("block:list-add-trafficSignalsAltered",{trafficSignalsAltered:0, blockId:this.value[index].blockId});
				}
			}
		},



		onToggleExpand: function() {
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-trafficSignalsAltered",{expand:!this.preset[0].expandTrafficSignalsAltered});
		},
		onToggleExpandSingle(uindex) {
			this.showPanel = !this.showPanel;
			Vue.prototype.$bus.$emit("preset-block:expand-trafficSignalsAltered",{expand:!this.preset[0].expandTrafficSignalsAltered});
		},

		onApplySingle: function(uindex) {
			this.showPanel = false;
			setTimeout(() => {
				// Vue.prototype.$bus.$emit("preset-block:collapse-traffic");
				Vue.prototype.$bus.$emit("preset-block:expand-trafficSignalsAltered",{expand:false});
			}, 250);
		},

		onSwipeRight() {
			this.showPanel = false;
			setTimeout(() => {
				// Vue.prototype.$bus.$emit("preset-block:collapse-traffic");
				Vue.prototype.$bus.$emit("preset-block:expand-trafficSignalsAltered",{expand:false});
			}, 250);
		},

	}
}
</script>
